var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"box"},[_c('img',{staticStyle:{"width":"80%"},attrs:{"src":'http://www.xinhuoa.com:2363/upload/' + _vm.listitem.more.thumbnail,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.listitem.post_title))]),_vm._v(" "),_c('div',{staticClass:"more"},[_vm._v("了解更多")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f21f5c68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = null
// module chunks = 